import { useDispatch } from 'react-redux';
import { updateCashbox } from '@redux/features/cashboxesSlice';
import { CASHBOX_TYPES } from 'constants/cashboxTypes';
import { AccountForm } from './AccountForm';

export const EditAccountForm = ({ cashbox, isOpen, setIsOpen }) => {
  const dispatch = useDispatch();

  const onSubmit = async (values, { resetForm }) => {
    const submitData = {
      id: cashbox.id,
      balance: parseInt(values.balance),
      method: { id: values.method?.id, label: values.method.label },
    };

    if (cashbox.type !== CASHBOX_TYPES.SAFE) {
      submitData.name = values.name;
    }

    const resultAction = await dispatch(updateCashbox(submitData));

    if (updateCashbox.fulfilled.match(resultAction)) {
      setIsOpen(false);
      resetForm();
    }
  };

  return (
    <AccountForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title='Редагувати рахунок'
      submitText='Редагувати'
      balanceLabel='Поточний баланс'
      balancePlaceholder='Введіть поточний баланс'
      initialValues={{
        name: cashbox?.name,
        balance: cashbox?.balance,
        method: cashbox?.methods?.find((m) => m.type === 'basic') || '',
      }}
      onSubmit={onSubmit}
      hideBalanceField
    />
  );
};
